// extracted by mini-css-extract-plugin
export default {"whyUsSection":"whyus_whyUsSection__PjFHR","features":"whyus_features__VXH6-","feature":"whyus_feature__6Iwnw","icon":"whyus_icon__Fo8Pv"};